import { Module, MutationTree, ActionTree, GetterTree } from 'vuex';
import { ModelEmsPayload, ModelEmsResponse } from '@/models/outbounds';

export class GlobalMailState {
  public ems: ModelEmsPayload = new ModelEmsPayload();
  public emsResponse: ModelEmsResponse = new ModelEmsResponse();
  public receptionTimePopup = false;

  public customerDropOffMethod: outbound.itemDeliveryMethod = '';
  public nowIspickupReserveOvertime?: boolean = false;
  public nowIspickupServiceOvertime?: boolean = false;
}

const Mutations: MutationTree<GlobalMailState> = {
  updateEms(state: GlobalMailState, payload: ModelEmsPayload) {
    state.ems = payload;
  },
  updateEmsResponse(state: GlobalMailState, payload: ModelEmsResponse) {
    state.emsResponse = payload;
  },
  updateReceptionTimePopup(state: GlobalMailState, payload: boolean) {
    state.receptionTimePopup = payload;
  },
  updateCustomerDropOffMethod(state: GlobalMailState, payload: outbound.itemDeliveryMethod) {
    state.customerDropOffMethod = payload;
  },
  updateNowIspickupReserveOvertime(state: GlobalMailState, payload: boolean) {
    state.nowIspickupReserveOvertime = payload;
  },
  updateNowIspickupServiceOvertime(state: GlobalMailState, payload: boolean) {
    state.nowIspickupServiceOvertime = payload;
  },
};
const Actions: ActionTree<GlobalMailState, any> = {
  updateEms({ commit }, payload: ModelEmsPayload) {
    commit('updateEms', payload);
  },
  updateEmsResponse({ commit }, payload: ModelEmsResponse) {
    commit('updateEmsResponse', payload);
  },
  updateReceptionTimePopup({ commit }, payload: boolean) {
    commit('updateReceptionTimePopup', payload);
  },
  updateNowIspickupReserveOvertime({ commit }, payload: boolean) {
    commit('updateNowIspickupReserveOvertime', payload);
  },
  updateNowIspickupServiceOvertime({ commit }, payload: boolean) {
    commit('updateNowIspickupServiceOvertime', payload);
  },
  updateCustomerDropOffMethod({ commit }, payload: outbound.itemDeliveryMethod) {
    commit('updateCustomerDropOffMethod', payload);
  },
};

const Getters: GetterTree<GlobalMailState, any> = {
  getNowIspickupReserveOvertime(state: GlobalMailState) {
    return state.nowIspickupReserveOvertime;
  },
  getNowIspickupServiceOvertime(state: GlobalMailState) {
    return state.nowIspickupServiceOvertime;
  },
  getCustomerDropOffMethod(state: GlobalMailState) {
    return state.customerDropOffMethod;
  },
};

const module: Module<GlobalMailState, any> = {
  namespaced: true,
  state: new GlobalMailState(),
  mutations: Mutations,
  actions: Actions,
  getters: Getters,
};

export default module;
